import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" {...props}><path fillRule="evenodd" d="M34 18c0 8.837-7.163 16-16 16S2 26.837 2 18 9.163 2 18 2a16 16 0 0116 16zm-1.5 0c0-8.008-6.492-14.5-14.5-14.5S3.5 9.992 3.5 18 9.992 32.5 18 32.5c8.004-.009 14.491-6.496 14.5-14.5zm-2 0c0-6.904-5.596-12.5-12.5-12.5S5.5 11.096 5.5 18 11.096 30.5 18 30.5c6.9-.008 12.492-5.6 12.5-12.5z" /></svg>);